import React from 'react';

function Skills(){
    return (
        <div>
            <section id="skills" className="responsive">
            <div id="skills-icon" className="wrapper">
            <h2 className="section-heading">Skills</h2>
            <div className="skills-box panel"><i className="fab fa-html5"></i><p>HTML</p></div>
                <div className="skills-box panel"><i className="fab fa-css3-alt"></i><p>CSS</p></div>
                <div className="skills-box panel"><i className="fab fa-js"></i><p>JavaScript</p></div>
                <div className="skills-box panel"><i className="fab fa-node"></i><p>Node JS</p></div>
                <div className="skills-box panel"><i class="fab fa-react"></i><p>React</p></div>
                <div className="skills-box panel"><i className="fab fa-wordpress"></i><p>WordPress</p></div>
                <div className="skills-box panel"><i className="flaticon-adobe-illustrator"></i><p>Illustrator</p></div>
                <div className="skills-box panel"><i className="flaticon-adobe-photoshop-logo"></i><p>Photoshop</p></div>
            </div>
        </section>

        </div>

        
    )
}

export default Skills;